<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование" : "Добавление"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs4)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            :rules="[$rules.required]"
            v-model='model.name'
            label='Название'
          )
        v-flex(xs4)
          v-select(
            v-model='model.mark_kind'
            :items='kinds'
            item-value='kind'
            item-text='name'
            label='Тип метки'
          )
        v-flex(xs4)
          s-sites-picker(
            v-model='model.site_id'
            label='Для сайта'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("width")'
            :error-messages='errors.first("width")'
            :rules="[$rules.number]"
            v-model='model.width'
            label='Ширина (px)'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("height")'
            :error-messages='errors.first("height")'
            :rules="[$rules.number]"
            v-model='model.height'
            label='Высота (px)'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("offcet_x")'
            :error-messages='errors.first("offcet_x")'
            :rules="[$rules.number]"
            hint="Пример: если ширина 100, то смещение 50"
            v-model='model.offcet_x'
            label='Смещение X (px)'
          )
        v-flex(xs3)
          v-text-field(
            :error='errors.has("offcet_y")'
            :error-messages='errors.first("offcet_y")'
            :rules="[$rules.number]"
            hint="Пример: если высота 100, то смещение 100"
            v-model='model.offcet_y'
            label='Смещение Y (px)'
          )
        v-flex(xs4)
          s-auto-image-upload(
            v-model='model.icon'
            :src='model.icon_url'
            :parseResponse='r => r.hash'
            label='Иконка'
          )
        v-flex(xs4)
          v-select(
            v-model='model.corp_mark_type_id'
            :items='corpMarks'
            item-text="name"
            item-value="id"
            label='Иконка для отображения на корпоративном сайте'
            clearable
          )
            template(slot="item" slot-scope="option")
              div(class="option")
                div
                  img(:src="option.item.icon_url" class="option-img")
                div {{ option.item.name }}
            template(slot="selection" slot-scope="option")
              div(class="option")
                div
                  img(:src="option.item.icon_url" class="selection-option-img")
                div {{ option.item.name }}
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import http from "@/http";

export default {
  props: ['id'],

  data: () => ({
    model: {},
    kinds: [
      { kind: 'map', name: 'На карту' },
      { kind: 'genplan', name: 'На генплан' }
    ],
    attributes: []
  }),

  async created() {
    this.fetchAttributes()
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.model = (await this.fetchSingle({ id: this.id })).data
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/marktypes/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async onSave() {
      if (this.model.corp_mark_type_id === undefined)
        this.model.corp_mark_type_id = null
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'InfrastructureDictionary.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('dictionaries/infrastructure', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    corpMarks() {
      return this.attributes[`mark_types.${this.model.mark_kind}`]
    },
    ...mapGetters('dictionaries/infrastructure', ['isLoading'])
  }
}
</script>

<style scoped>
.option {
  display: flex;
  gap: 10px;
  align-items: center;
}

.option-img {
  width: 30px;
  margin-bottom: -10px;
  display: block;
}

.selection-option-img {
  width: 20px;
  margin-bottom: -5px;
}
</style>
